import React, { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';
import Loading from '../Loading/Loading';




const Shop = () => {

    const [searchTerm, setSearchTerm] = useState('');
    const [filteredShops, setFilteredShops] = useState([]);

    const { data, isLoading } = useQuery('details', () =>
        fetch(
            `${process.env.REACT_APP_SECRET_API}/shop?include=media`,
            {
                method: 'GET',
                headers: {
                    'content-type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest',
                    authorization: `Bearer ${localStorage.getItem('token')}`,
                },
            }
        )
            .then((res) => res.json())
            .then((data) => {
                setFilteredShops(data?.data);
                return data;
            })
    );

    const navigate = useNavigate();

    const redirectToShopProducts = (shopId, shopName) => {
        navigate(`/shop-products/${shopId}/${shopName}`);
    };

    const handleSearchTermChange = (e) => {
        setSearchTerm(e.target.value);
    };

    useEffect(() => {
        const filtered = data?.data.filter((shop) =>
            shop?.name.toLowerCase().includes(searchTerm.toLowerCase())
        );
        setFilteredShops(filtered);
    }, [data, searchTerm]);

    const shopList = filteredShops?.length > 0 ? filteredShops : data?.data;

    if (isLoading) {
        return <Loading />;
    }

    console.log(shopList)
    return (
        <div>
            <div className="container py-5">
                <div className="mb-4">
                    <input
                        type="text"
                        className="w-full px-3 py-2 border border-gray-300 rounded-md"
                        placeholder="Search shops by name"
                        value={searchTerm}
                        onChange={handleSearchTermChange}
                    />
                </div>
                <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
                    {shopList?.map((shop, index) => (
                        <button onClick={() => redirectToShopProducts(shop.id, shop.name)}>
                            <div className="relative flex cursor-pointer items-center rounded border border-gray-200 p-5">
                                <div className="relative flex h-14 w-14 shrink-0 items-center justify-center overflow-hidden rounded-full bg-gray-300">
                                    <img alt="Logo" loading="lazy" decoding="async" data-nimg="fill" className="object-cover" sizes="(max-width: 768px) 100vw" src={shop?.profile?.original_url} style={{ position: "absolute", height: "100%", width: "100%", inset: "0px", color: "transparent" }} />
                                </div>
                                <div className='flex flex-col ml-4 mr-4'>
                                    <span className='mb-2 lg:text-lg sm:text-sm font-semibold text-left text-heading'>{shop?.name}</span>
                                    {/* <span className='flex text-xs text-body text-left'>
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" className="h-3.5 w-3.5 shrink-0 text-muted ltr:mr-1 rtl:ml-1">
                                            <path d="M256 0C161.896 0 85.333 76.563 85.333 170.667c0 28.25 7.063 56.26 20.49 81.104L246.667 506.5c1.875 3.396 5.448 5.5 9.333 5.5s7.458-2.104 9.333-5.5l140.896-254.813c13.375-24.76 20.438-52.771 20.438-81.021C426.667 76.563 350.104 0 256 0zm0 256c-47.052 0-85.333-38.281-85.333-85.333S208.948 85.334 256 85.334s85.333 38.281 85.333 85.333S303.052 256 256 256z" fill="currentColor"></path>
                                        </svg>
                                        {shop.address}
                                    </span> */}
                                </div>
                            </div>
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Shop;